import React, { useEffect, useState } from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'

function ActivityFilter({
  id,
  tasks,
  categories,
  filter,
  applyFilter,
  filterCategories,
  isCardView,
  isActiveTasks,
}) {
  const [categoryOptions, setCategoryOptions] = useState([])
  const [processOptions, setProcessOptions] = useState([])
  const [activityOptions, setActivityOptions] = useState([])

  const filterCustom =
    isCardView && isActiveTasks && filterCategories?.length > 0 ? filterCategories : tasks

  useEffect(() => {
    let updatedCategoryOptions = []

    // Extract unique categories
    if (filterCustom) {
      updatedCategoryOptions = filterCustom.reduce((acc, cur) => {
        const exists = acc.some((item) => item.id === cur.process_category_id)
        if (!exists) {
          const categoryName = categories?.find((cat) => cat.id === cur.process_category_id)?.name
          if (categoryName) {
            acc.push({ id: cur.process_category_id, name: categoryName })
          }
        }
        return acc
      }, [])
      setCategoryOptions(updatedCategoryOptions)
    }

    // Process Options
    if (filter.categoryId) {
      const filteredProcesses = filterCustom.reduce((acc, cur) => {
        if (String(cur.process_category_id) === String(filter.categoryId)) {
          const exists = acc.some((item) => item.id === cur.process_template_id)
          const templateName = cur.process_template_name || cur.process_templates
          if (!exists && templateName) {
            acc.push({ id: cur.process_template_id, name: templateName })
          }
        }
        return acc
      }, [])
      setProcessOptions(filteredProcesses)
    } else {
      setProcessOptions([])
    }

    // Activity Options
    if (filter.processTemplateId) {
      const filteredActivities = filterCustom.reduce((acc, cur) => {
        if (cur.process_template_id === filter.processTemplateId) {
          const exists = acc.some((item) => item.id === cur.activity_template_id)
          if (!exists && cur.activity_template_name) {
            acc.push({ id: cur.activity_template_id, name: cur.activity_template_name })
          }
        }
        return acc
      }, [])
      setActivityOptions(filteredActivities)
    } else {
      setActivityOptions([])
    }
  }, [filter, tasks, isActiveTasks, filterCategories])

  const isValidOption = (value, options) => options.some((opt) => opt.id === value)
  const getSelectValue = (value, options) =>
    value && isValidOption(value, options) ? value : 'All'

  return (
    <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
      {/* Category Dropdown */}
      <FormControl className="task-filter " size="small" style={{ minWidth: 160 }}>
        <InputLabel>Category</InputLabel>
        <Select
          value={getSelectValue(filter.categoryId, categoryOptions)}
          label="Category"
          onChange={(e) => {
            const selected = e.target.value
            applyFilter({
              categoryId: selected !== 'All' ? selected : null,
              processTemplateId: null,
              activityTemplateId: null,
            })

            if (selected !== 'All') {
              sessionStorage.setItem('filterCategory', JSON.stringify(selected))
            } else {
              sessionStorage.removeItem('filterCategory')
              sessionStorage.removeItem('filterProcess')
              sessionStorage.removeItem('filterActivity')
            }
          }}
          style={{ borderRadius: '50px' }}
        >
          <MenuItem value="All">All</MenuItem>
          {categoryOptions.map((cat) => (
            <MenuItem key={cat.id} value={cat.id}>
              {cat.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Process Dropdown */}
      {filter.categoryId && (
        <FormControl className="task-filter " size="small" style={{ minWidth: 160 }}>
          <InputLabel>Process</InputLabel>
          <Select
            value={getSelectValue(filter.processTemplateId, processOptions)}
            label="Process"
            onChange={(e) => {
              const selected = e.target.value
              applyFilter({
                ...filter,
                processTemplateId: selected !== 'All' ? selected : null,
                activityTemplateId: null,
              })

              if (selected !== 'All') {
                sessionStorage.setItem('filterProcess', JSON.stringify(selected))
              } else {
                sessionStorage.removeItem('filterProcess')
                sessionStorage.removeItem('filterActivity')
              }
            }}
            style={{ borderRadius: '50px' }}
          >
            <MenuItem value="All">All</MenuItem>
            {processOptions.map((proc) => (
              <MenuItem key={proc.id} value={proc.id}>
                {proc.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Activity Dropdown */}
      {filter.processTemplateId && (
        <FormControl className="task-filter " size="small" style={{ minWidth: 160 }}>
          <InputLabel>Activity</InputLabel>
          <Select
            value={getSelectValue(filter.activityTemplateId, activityOptions)}
            label="Activity"
            onChange={(e) => {
              const selected = e.target.value
              applyFilter({
                ...filter,
                activityTemplateId: selected !== 'All' ? selected : null,
              })

              if (selected !== 'All') {
                sessionStorage.setItem('filterActivity', JSON.stringify(selected))
              } else {
                sessionStorage.removeItem('filterActivity')
              }
            }}
            style={{ borderRadius: '50px' }}
          >
            <MenuItem value="All">All</MenuItem>
            {activityOptions.map((act) => (
              <MenuItem key={act.id} value={act.id}>
                {act.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  )
}
export default ActivityFilter
